import { useState, useEffect } from 'react';
import { user } from 'src/backend';
import { useSnackbar } from 'notistack';
import useAuth from './useAuth';

/**
 * Hook to check if the current user's team is pending approval
 */
export default function useApprovalStatus() {
  const { isAuthenticated, user: authUser } = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  const [approvalStatus, setApprovalStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchApprovalStatus = async () => {
    if (!isAuthenticated || !authUser?.team_id) {
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await user.getApprovalStatus();
      setApprovalStatus(response);
    } catch (err) {
      setError(err);
      enqueueSnackbar('Failed to fetch approval status', { variant: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchApprovalStatus();
  }, [isAuthenticated, authUser?.team_id]);

  const isPendingApproval = approvalStatus?.isPendingApproval || false;

  return {
    approvalStatus,
    isPendingApproval,
    queueEntry: approvalStatus?.queueEntry || null,
    isLoading,
    error,
    refetch: fetchApprovalStatus,
  };
}
